import { ILinkFile, IUploadFile } from "@/models";
import { Vue, Component, Prop, Watch } from "vue-property-decorator";

@Component({
    name: "Mediamodal",
})
export default class MediaModal extends Vue {
    @Prop({ default: false, type: Boolean })
    public state?: boolean;

    @Prop({ type: Array, default: [] })
    public initialLinks: Array<ILinkFile>;

    @Prop({ type: Array, default: [] })
    public initialFiles: Array<IUploadFile>;

    @Prop({ type: Array, default: () => ([]) })
    public currentFiles: File[];

    public existingFiles = [];

    public links = [];

    public files: File[] = [];

    public localState = false;

    constructor() {
        super();

        this.links = this.initialLinks;
        this.existingFiles = this.initialFiles;
        this.files = this.currentFiles.map(p => p);
    }

    @Watch("state")
    setLocalState(): void {
        this.localState = this.state;
    }

    @Watch("localState")
    setCloseState(): void {
        if (!this.localState) {
            this.$emit("close");
        }
    }

    close(): void {
        this.$emit("close");
    }

    save(): void {
        this.$emit("changeFiles",  this.files);

        this.$emit(
            "removeFiles",
            this.initialFiles.filter(file => !this.existingFiles.includes(file)),
        );

        this.$emit(
            "changeLinks",
            this.links.filter(curr => curr.link),
        );
    }

    addDroppedFiles(event: DragEvent) {
        const droppedFiles = event.dataTransfer.files;

        if (droppedFiles.length) {
            this.files.push(...droppedFiles);
        }
    }

    addSelectedFiles(selectedFiles: File[]) {
        if (selectedFiles.length) {
            this.files.push(...selectedFiles);
        }
    }

    addEmptyLink() {
        let emptyLink: ILinkFile = {
            id: null,
            link: "",
        };
        this.links = [...this.links, emptyLink];
    }

    updateLinkValue(value, index) {
        this.links[index].link = value;
    }

    removeLink(index) {
        this.links = [
            ...this.links.slice(0, index),
            ...this.links.slice(index + 1),
        ];
    }

    removeFile(index) {
        this.files = [
            ...this.files.slice(0, index),
            ...this.files.slice(index + 1),
        ];
    }

    removeExistingFile(importFileId: number) {
        this.existingFiles = this.existingFiles.filter(file => file.importFileId !== importFileId );
    }

    async mounted(): Promise<void> {}
}
